import React from 'react'
import InlineDocumentation from '../components/inlineDocumentation'
import { Nav, NavItem, Container, Row, Col, DropdownButton, ButtonGroup, Button, Dropdown, Navbar } from 'react-bootstrap'

import { Link } from "react-router-dom";
import { withRouter } from 'react-router'

import { AcuadoriPlatformDocumentation, AcuadoriPlatformDocumentationChapter } from './AcuaSmartPlatform/docAcuaSmartPlatform'
import BackToTop from "react-back-to-top-button"
import { NavDropdown } from 'react-bootstrap';

class DocAcuadori extends React.Component {
    static defaultProps = {
        basePath: '/docs',
        title: 'Acuadori Docs',
        pages: [
            AcuadoriPlatformDocumentation,
            AcuadoriPlatformDocumentationChapter
            // SIDEBAR Elements
            // {
            //     title: 'Dropdown', chapters: [
            //         { title: "item 1.1" },
            //         { title: "item1.2" },
            //         { title: "item1.3" },
            //     ]
            // },
            // { title: "item2" },
            // { title: "item3" }
        ],

        // From react-router.withRouter
        // match: {"path":"/docs/:path","url":"/docs/AcuadoriDoc","isExact":true,"params":{"path":"AcuadoriDoc"}},
        // location: {"pathname":"/docs/AcuadoriDoc","search":"","hash":"","key":"456mne"},
        // history: {"length":47,"action":"PUSH","location":{"pathname":"/docs/AcuadoriDoc","search":"","hash":"","key":"456mne"}},
    };
    constructor(props) {
        super(props);
        this.state = {
            url: props.match.path.split(':')[0],
        }
    }

    setPage = (url) => {

        return this.setState({ url: url });
    }

    makeButton = (item) => {
        return <div className="border-0 justify-content-start">{item}</div>
    }

    render() {
        let pathUrl = this.props.match.params.path;
        let pathHistory = this.props.history;
        let url = this.props.basePath;
        let { pages } = this.props;
        let documentation = {};
        for (let i = 0; i < pages.length; i++) {
            if (pathUrl === pages[i].title) {
                if ('document' === pages[i].type) {
                    documentation = pages[i];
                }
                if (pathHistory) {

                }
                break;
            }
        }
        return (
            <div >
                <Navbar bg='light' expand={'sm'} className={'d-flex flex-row m-1 justify-content-center'}>
                    {
                        pages.map((item, index) => {
                            if (item.type === 'document') {
                                return (
                                    <Nav.Link href={`#${item.title}`} >
                                        <Button>
                                            {item.title}
                                        </Button>
                                    </Nav.Link>
                                )
                            }
                            else if (item.type === 'chapter') {
                                return (
                                    item.chapters.map((chapter, index) => {
                                        if (chapter.paragraph.length > 0) {
                                            return (
                                                <Dropdown className={'m-1'} as={ButtonGroup}>
                                                    <Button href={`#${chapter.name}`}>{chapter.name}</Button>
                                                    <Dropdown.Toggle split id="dropdown-split-basic" />
                                                    <Dropdown.Menu>
                                                        {
                                                            chapter.paragraph.map((paragraph) => {
                                                                return <Dropdown.Item href={`#${paragraph}`}>{paragraph}</Dropdown.Item>
                                                            })
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )
                                        }
                                        else {
                                            return /*this.makeButton*/(
                                                <Button href={`#${chapter.name}`} className={'m-1'}>{chapter.name}</Button>
                                            )
                                        }
                                    }
                                    )
                                )
                            }
                            else {
                                return (
                                    <NavItem>
                                        {this.makeButton(<Link to={`${url}/${item.title}`} onClick={() => this.setPage(item.title)}>{item.title}</Link>)}
                                    </NavItem>
                                )
                            }

                        })
                    }
                </Navbar>
                <Container fluid>
                    <BackToTop
                        showAt={100}
                        speed={1500}
                        easing="easeInOutQuint"
                    >
                        <Button className={'m-1'}>Top</Button>
                    </BackToTop>
                    {
                        (documentation.type === 'document') ? documentation.document :
                            <InlineDocumentation
                                title={documentation.title}
                                subtitle={documentation.subtitle}
                                brief={documentation.brief}
                                abstract={documentation.abstract || null}
                                content={documentation.content && (<div>
                                    <p>{documentation.content}</p>
                                    {documentation.steps && <p><h4 className='text-success'>STEPS:</h4></p>}
                                </div>)}
                            />
                    }
                </Container>
            </div >

        );
    }

}

export default withRouter(DocAcuadori)
// export default DocAcuadori
export {
    DocAcuadori
}